var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToolsSmIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 38,
    viewBox: "0 0 39 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.5,
    cy: 19,
    r: 19,
    fill: "#F5F5F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2172 11.5719L17.9703 11.1187C18.6453 10.7125 19.4172 10.5 20.2047 10.5C21.3547 10.5 22.4609 10.9563 23.2734 11.7719L25.2703 13.7687C25.7391 14.2375 26.0016 14.875 26.0016 15.5375V16.5031L26.6172 17.1188C27.1047 16.6312 27.8953 16.6312 28.3859 17.1188C28.8766 17.6063 28.8734 18.3969 28.3859 18.8875L26.3859 20.8875C25.8984 21.375 25.1078 21.375 24.6172 20.8875C24.1266 20.4 24.1297 19.6094 24.6172 19.1187L24.0016 18.5H23.0359C22.3734 18.5 21.7359 18.2375 21.2672 17.7688L19.7328 16.2344C19.2641 15.7656 19.0016 15.1281 19.0016 14.4656V14.0687C19.0016 13.7188 18.8172 13.3906 18.5172 13.2125L17.2172 12.4312C16.8922 12.2375 16.8922 11.7688 17.2172 11.575V11.5719ZM11.0859 23.5844L18.0266 16.6438L20.8547 19.4719L13.9141 26.4125C13.1328 27.1938 11.8672 27.1938 11.0859 26.4125C10.3047 25.6313 10.3047 24.3656 11.0859 23.5844Z",
    fill: "#3C5199"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToolsSmIcon);
export default __webpack_public_path__ + "static/media/tools-sm-icon.523a0d397963c5c6c75f172908158b7a.svg";
export { ForwardRef as ReactComponent };